module.exports = __webpack_public_path__ + "static/media/D8.794da7be.png";